<template>
  <div>
    <input
      id="filebtn"
      :value="uploadValue"
      type="file"
      accept="image/jpg, image/jpeg, image/gif, image/png"
      name="image"
      @change="setImage"
    />
    <div
      class="modal fade sss"
      id="cropper-dialog"
      role="dialog"
      data-backdrop="false"
      tabindex="-1"
      aria-hidden="true"
      aria-labelledby="myModalLabel"
    >
      <div class="modal-dialog" style="width: 500px" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title" id="myModalLabel">上传图片</h4>
          </div>
          <div class="modal-body">
            <div class="crop-image" v-if="imgSrc">
              <vue-cropper
                ref="cropper"
                :guides="true"
                :view-mode="2"
                drag-mode="crop"
                :aspect-ratio="1"
                :auto-crop-area="0.9"
                :min-container-width="500"
                :min-container-height="300"
                :background="true"
                :rotatable="true"
                :src="imgSrc"
                alt="Source Image"
                :img-style="{ height: '300px' }"
              ></vue-cropper>
              <img
                v-if="cropImg && false"
                :src="cropImg"
                style="width: 100px; height: 100px; border: 1px solid gray"
                alt="Cropped Image"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              关闭
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :disabled="isDisabled"
              @click="cropImage"
            >
              {{ uploadTxt }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import { publicFileUpload } from "@/api/common/index";
export default {
  name: "cropper",
  components: { VueCropper },
  data() {
    return {
      uploadValue: "",
      cropImg: "",
      imgSrc: "",
      uploadTxt: "上传",
      isDisabled: false,
    };
  },
  methods: {
    setImage(e) {
      this.uploadValue = "";
      const file = e.currentTarget.files[0];
      if (!file) {
        return;
      }
      if (!file.type.includes("image/")) {
        this.$message({
          type: "warning",
          message: "请选择一个图片类型文件",
        });
        return;
      }
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.imgSrc = event.target.result;
          // rebuild cropperjs with the updated source
          this.$nextTick(() => {
            this.$refs.cropper.replace(event.target.result);
          });
          $("#cropper-dialog").modal("show");
        };

        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
    },
    cropImage() {
      this.isDisabled = true;
      this.uploadTxt = "正在上传...";
      this.$refs.cropper
        .getCroppedCanvas({
          width: 400,
          height: 400,
          imageSmoothingEnabled: false,
          imageSmoothingQuality: "high",
        })
        .toBlob((blob) => {
          const formData = new FormData();
          formData.append("file", blob);
          formData.append("group_number", null);
          formData.append("type", 1);
          publicFileUpload(formData)
            .then((res) => {
              if (res.status_code === 200) {
                $("#cropper-dialog").modal("hide");
                this.uploadTxt = "上传";
                this.isDisabled = false;
                this.$emit("complete");
              } else {
                $("#cropper-dialog").modal("hide");
                this.uploadTxt = "上传";
                this.isDisabled = false;
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.uploadTxt = "上传";
              this.isDisabled = false;
              this.$message({
                type: "error",
                message: err,
              });
            });
        });
    },
    cropMove() {
      this.cropImg = this.$refs.cropper
        .getCroppedCanvas({
          width: 400,
          height: 400,
          imageSmoothingEnabled: false,
          imageSmoothingQuality: "high",
        })
        .toDataURL();
    },
  },
  // mounted() {
  //   $("#cropper-dialog").on("hidden.bs.modal", () => {
  //     this.$refs.cropper.clear();
  //   });
  // },
};
</script>

<style scoped>
.modal-header {
  padding: 15px;
}
.modal-body {
  height: 350px;
  padding: 0px 0px 30px 0px;
}
.crop-image {
  width: 100%;
  height: 100%;
}
#filebtn {
  visibility: hidden;
}
</style>